import { Link } from "react-router-dom";
import { Box, SxProps, Theme, Tooltip } from "@mui/material";
import { RealTimeItemMonitoring } from "@common/components/ListDetailViews/common/RealTimeStatus/type";
import { getStatus } from "@common/utils/devices/monitoringSources/helpers/getStatus";

interface DeviceCardMonitoringStatusItemProps {
  linkTo: string;
  previousPage?: string;
  item: RealTimeItemMonitoring;
  isDevicePaused?: boolean;
}

const borderSx: SxProps<Theme> = (theme: Theme) => ({
  border: "2px solid",
  borderRadius: "50%",
  padding: theme.spacing(0.5),
  fontSize: "2rem",
});

const getStatusColorMap = ({ palette }: Theme) => ({
  success: palette.success.main,
  error: palette.error.main,
  troubleshooting: palette.error.main,
  unknown: palette.grey[400],
  paused: palette.device.faded,
  default: palette.success.main,
  enabledPaused: palette.grey[400],
});

type Status = ReturnType<typeof getStatus>;

const getColorsSx = (status: Status) => (theme: Theme) => ({
  color: getStatusColorMap(theme)[status],
  borderColor: getStatusColorMap(theme)[status],
});

export const DeviceCardMonitoringStatusItem = ({
  linkTo,
  previousPage,
  item,
  isDevicePaused = false,
}: DeviceCardMonitoringStatusItemProps) => {
  return (
    <Link to={linkTo} state={{ previous: previousPage }}>
      <Tooltip arrow title={item.tooltip}>
        <Box
          sx={[
            borderSx,
            getColorsSx((isDevicePaused ? "paused" : item.status) as Status),
            {
              display: "flex",
              alignItems: "center",
              width: "32px",
              height: "32px",
              justifyContent: "center",

              "& svg": {
                maxWidth: "100%",
              },
            },
          ]}
        >
          {item.icon}
        </Box>
      </Tooltip>
    </Link>
  );
};
